import { render } from "./MainHome.vue?vue&type=template&id=e9c18c18"
import script from "./MainHome.vue?vue&type=script&lang=js"
export * from "./MainHome.vue?vue&type=script&lang=js"

import "./MainHome.vue?vue&type=style&index=0&id=e9c18c18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__